// eslint-disable-next-line
export default [
	{
		id: 1,
		bglight: "#FCEDC5",
		bgdark: "#FCEDC5",
		icon: "/svgs/juices.svg",
		text: "Juice",
	},
	
	{
		id: 2,
		bglight: "#FFC5C2",
		bgdark: "#FFC5C2",
		icon: "/svgs/sodaDrinks.svg",
		text: "Soda",
	},
	{
		id: 3,
		bglight: "#F8D5C5",
		bgdark: "#F8D5C5",
		icon: "/svgs/category_fruitwine.svg",
		text: "fruit wine",
	},
	{
		id: 4,
		bglight: "#C2E9FF",
		bgdark: "#C2E9FF",
		icon: "/svgs/water.svg",
		text: "Water",
	},
	{
		id: 5,
		bglight: "#E0F1CC",
		bgdark: "#E0F1CC",
		icon: "/svgs/yoghurt.svg",
		text: "Yoghurt",
	},
	
];
